module.exports = __webpack_public_path__ + "img/logo.82b5c24c.png";